import React from "react";
import { Page } from "components/common";
import { Row, Col, Nav } from "reactstrap";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { LocalForm, Control } from "react-redux-form";
import { FormGroup } from "components/common/Forms";
import GetBack from "components/refactoring/BackButton";

const colStyle = {
    xs: false,
    md: 12,
    className: "pt-1 pb-1"
  }

const SubscriptionSettings = () => {

    const {t} = useTranslation()

    return (
        <Page title="Genneral Settings">
        <GetBack styleClass="my-2"/>
        <LocalForm
        >
          <Row className="mb-1">
            <Col {...colStyle}>
              <FormGroup label="Tax Rate">
                <Control.text model=".tax_rate" />
              </FormGroup>
            </Col>
            <Col {...colStyle}>
              <FormGroup label="Payment Account" addControlClass={false}>
                <Control.text model=".payment_account" component={Select} />
            </FormGroup>
            </Col>
          </Row>
        </LocalForm>
      </Page>
)};

export default SubscriptionSettings;
